import dayjs from "dayjs";

export const formatDateCell = (value?: Date | null) => {
	if (!value) return "";

	return dayjs(value).format("MM/DD/YYYY");
};

/**
 * Readable relative label for timestamps.
 */
export function formatRelativeDate(
	date: Date | string | number | null | undefined
): string {
	if (date == null) return "";
	const d = dayjs(date);
	if (!d.isValid()) return "";

	const now = dayjs();
	const calendarDaysAgo = now.startOf("day").diff(d.startOf("day"), "day");

	if (calendarDaysAgo < 0) {
		return d.toDate().toLocaleString(undefined, {
			dateStyle: "medium",
			timeStyle: "short"
		});
	}
	if (calendarDaysAgo === 0) {
		const timeStr = d.toDate().toLocaleTimeString(undefined, {
			hour: "numeric",
			minute: "2-digit",
			hour12: true
		});
		return `Today at ${timeStr}`;
	}
	if (calendarDaysAgo === 1) return "1 day ago";
	return `${calendarDaysAgo} days ago`;
}